import React from "react";
import { Tooltip } from "@sscs/ui";
import styles from "./cveButtonIcon.module.scss";
import CveTooltipCard, { CveTooltipHeader, } from "./CveTooltipCard";
const hasTooltipContent = (data, viewAllLink) => viewAllLink !== undefined ||
    (data !== undefined &&
        (data.totalCount !== undefined ||
            data.fixableCount !== undefined ||
            data.mostSevere !== undefined));
const CveButtonIcon = ({ severity, tooltipData, viewAllLink, }) => {
    if (!severity) {
        return null;
    }
    const chip = React.createElement("div", { className: styles.cve }, "CVE");
    if (!hasTooltipContent(tooltipData, viewAllLink)) {
        return chip;
    }
    return (React.createElement(Tooltip, { tooltipType: "card", header: React.createElement(CveTooltipHeader, { totalCount: tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.totalCount }), title: React.createElement(CveTooltipCard, { ...tooltipData }), footer: viewAllLink && (React.createElement("div", { className: styles["view-all"] }, viewAllLink("View all vulnerabilities →"))) }, chip));
};
export default CveButtonIcon;
//# sourceMappingURL=CveButtonIcon.js.map